import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@angular/material';

import { DataTableModule, CalendarModule } from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';

import { IntegrationsComponent } from './integrations.component';
import { IntegrationListComponent } from './integrationlist/integration-list.component';
import { IntegrationComponent } from './integration/integration.component';

import { IntegrationService } from './integration.service';

@NgModule({
    declarations: [
        IntegrationsComponent,
        IntegrationListComponent,
        IntegrationComponent
    ],
    imports: [
        SharedModule,
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        FlexLayoutModule,
        DataTableModule,
        CalendarModule
    ],
    providers: [IntegrationService],
    entryComponents: [
        IntegrationComponent
    ]
})

/**
 * Main module for the Integration Management.
*/
export class IntegrationsModule { }



// WEBPACK FOOTER //
// ./src/app/admin/integrations/integrations.module.ts